'use es6';

import PropTypes from 'prop-types';
import PersonalizePopoverBodyEditLegacy from './PersonalizePopoverBodyEditLegacy';
import { useSettings } from './hooks/useSettings';
import { jsx as _jsx } from "react/jsx-runtime";
function PersonalizePopoverBodyEdit(props) {
  const {
    fetchSiteSettings
  } = props;
  const siteSettings = useSettings(fetchSiteSettings);
  return /*#__PURE__*/_jsx(PersonalizePopoverBodyEditLegacy, Object.assign({
    siteSettings: siteSettings
  }, props));
}
PersonalizePopoverBodyEdit.propTypes = {
  fetchSiteSettings: PropTypes.func
};
PersonalizePopoverBodyEdit.displayName = 'PersonalizePopoverBodyEdit';
export default PersonalizePopoverBodyEdit;